import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: 'ion-toggle[appAccessibleToggle]'
})
export class AccessibleToggleDirective implements OnInit {
  @Input() public appAccessibleToggleLabelledBy = '';

  constructor(private el: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  public ngOnInit(): void {
    this.applyAriaLabelledBy();
    this.syncAriaChecked();
  }

  @HostListener('keydown', ['$event'])
  public onKeydown(event: KeyboardEvent): void {
    const key = event.key;
    if (key !== 'Enter' && key !== ' ' && key !== 'Spacebar') {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.el.nativeElement.click();
    setTimeout(() => this.syncAriaChecked());
  }

  @HostListener('ionFocus')
  public onIonFocus(): void {
    this.renderer.addClass(this.el.nativeElement, 'toggle-focus-visible');
  }

  @HostListener('ionBlur')
  public onIonBlur(): void {
    this.renderer.removeClass(this.el.nativeElement, 'toggle-focus-visible');
  }

  @HostListener('ionChange')
  public onIonChange(): void {
    this.syncAriaChecked();
  }

  private applyAriaLabelledBy(): void {
    if (!this.appAccessibleToggleLabelledBy) {
      return;
    }
    this.renderer.setAttribute(this.el.nativeElement, 'aria-labelledby', this.appAccessibleToggleLabelledBy);
  }

  private syncAriaChecked(): void {
    const toggle = this.el.nativeElement as HTMLElement & { checked?: boolean };
    this.renderer.setAttribute(this.el.nativeElement, 'aria-checked', `${!!toggle.checked}`);
  }
}